<template>
  <div class="dft-attr_container">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="底部导航" name="attrsort">
        <h4 class="dft-header">底部导航</h4>
        <div class="attr-item-box" v-for="(item, index) in value[activeName]" :key="index"
          :style="{ 'padding': value.attr[item].isUse == false ? '0' : '6px' }">
          
          <div class="attr-item-typestyle" v-if="item == 'a0'">
            <div class="attr-item-label">{{ value.attr[item].label }}</div>
            <div class="attr-item-value">
              <div class="temp-box">
                <el-select v-model="value.attr[item].value" placeholder="请选择" style="width: 100%;">
                  <el-option v-for="(ii, iiIndex) in value.attr[item].selectOption.keys" :key="ii" :label="value.attr[item].selectOption.values[iiIndex]" :value="ii" class="select-option"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="attr-item-typestyle" v-else-if="item == 'a1'">
            <div class="attr-item-label">{{ value.attr[item].label }}</div>
            <div class="attr-item-value">
              <div class="temp-box">
                <el-checkbox v-model="value.attr[item].value" true-label="1" false-label="0"></el-checkbox>
              </div>
            </div>
          </div>
          <div class="attr-item-typedata" v-else-if="item == 'a2'">
            <div class="attr-item-label">{{ value.attr[item].label }}</div>
            <div class="attr-item-value">
              <div class="addImgList">
                <div class="img_info">建议图片尺寸750*350。</div>
                <div class="imgList_box">
                  <div class="imgList-item" v-for="(ii,iiIndex) in value.attr[item].value" :key="iiIndex"
                    >
                    <div class="ii-img-box">
                      <el-image v-if="ii.img0" class="ii-img" :src="ii.img0" fit="scale-down"></el-image>
                      <div class="ii-img-btn">
                        <el-upload
                          class="avatar-uploader-d"
                          :action="$uploadURL"
                          :show-file-list="false"
                          :on-success="(res, file)=>{handleChangeUploadSuccess(res, file,ii,iiIndex,'0')}"
                          :before-upload="beforeUpload"
                        >
                          <div class="">
                            更换图片
                          </div>
                        </el-upload>
                      </div>
                      <div class="img-info">未选中</div>
                    </div>
                    <div class="ii-img-box">
                      <el-image v-if="ii.img1" class="ii-img" :src="ii.img1" fit="scale-down"></el-image>
                      <div class="ii-img-btn">
                        <el-upload
                          class="avatar-uploader-d"
                          :action="$uploadURL"
                          :show-file-list="false"
                          :on-success="(res, file)=>{handleChangeUploadSuccess(res, file,ii,iiIndex,'1')}"
                          :before-upload="beforeUpload"
                        >
                          <div class="">
                            更换图片
                          </div>
                        </el-upload>
                      </div>
                      <div class="img-info">选中</div>
                    </div>
                    <div class="ii-link-box">
                      <div class="ii-link-btn">
                        <i class="el-icon-top icon_btn" title="上移" v-if="!['home','my'].includes(ii.key)&&classType=='1'&&![1].includes(iiIndex)" @click="moveUp(value.attr[item].value,iiIndex)"></i>
                        <i class="el-icon-bottom icon_btn" title="下移" v-if="!['home','my'].includes(ii.key)&&classType=='1'&&iiIndex!=(value.attr[item].value.length-2)" @click="moveDown(value.attr[item].value,iiIndex)"></i>
                        <i class="el-icon-delete icon_btn" title="删除" v-if="!['home','classify','cart','my'].includes(ii.key)" @click="mDelete(value.attr[item].value,iiIndex)"></i>
                      </div>
                      <div class="ii-link-info-box">
                        <!-- <div class="ii-link-info"></div> -->
                        <div class="ii-link">
                          <el-input v-model="ii.name" placeholder=""></el-input>
                        </div>
                      </div>
                      <div class="ii-link-info-box" v-if="!['classify','cart','my'].includes(ii.key)">
                        <div class="ii-link-info">跳转设置</div>
                        <div class="ii-link">
                          <el-select v-model="ii.url" placeholder="请选择" filterable style="width: 100%;">
                            <el-option v-for="(llitem,index) in navigatelist" :key="index" :label="llitem.pageName" :value="llitem.pageCode"
                              class="select-option" :disabled="llitem.disabled" :title="llitem.disabled?'暂不支持':''"></el-option>
                          </el-select>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="upload_btn select_btn" @click="addCroup(value.attr[item].value)"
                  :style="value.attr[item].value.length>=5?{'cursor': 'not-allowed','margin-top': '8px'}:'margin-top: 8px;'">
                  <i class="el-icon-plus"></i>
                  {{ ` 添加导航 ${value.attr[item].value.length}/5` }}
                </div>
                <!-- <el-upload
                  class="avatar-uploader-d"
                  :action="$uploadURL"
                  :show-file-list="false"
                  :on-success="(res, file)=>{handleUploadSuccess(res, file,value.attr[item])}"
                  :before-upload="beforeUpload"
                >
                  <div class="upload_btn">
                    <i class="el-icon-plus" ></i>
                    添加图片
                  </div>
                </el-upload> -->
              </div>
            </div>
          </div>
          <div class="attr-item-typedata" v-else-if="item == 'a3'">
            <div class="attr-item-label">{{ value.attr[item].label }}</div>
            <div class="attr-item-value">
              <el-checkbox v-for="(cii,ciiIndex) in value.attr[item].checkboxList" :key="ciiIndex" v-model="value.attr[item].value[ciiIndex]" disabled>{{cii}}</el-checkbox>
            </div>
          </div>
          <div class="attr-item-typestyle" v-else-if="item == 'a4'">
            <div class="attr-item-label">{{ value.attr[item].label }}</div>
            <div class="attr-item-value">
              <el-radio-group v-model="value.attr[item].value" size="small">
                <el-radio-button label="1">自定义模式</el-radio-button>
                <el-radio-button label="2">系统默认</el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <div class="attr-item-typestyle" v-if="['a5'].includes(item) && value.attr['a4'].value=='1'">
            <div class="attr-item-label">{{ value.attr[item].label }}</div>
            <div class="attr-item-on">{{ value.attr[item].showList[value.attr[item].value] || value.attr[item].value }}</div>
            <div class="attr-item-value">
              <div class="colorPicker">
                <el-button type="text" @click="value.attr[item].value = value.attr[item].default" class="resetBtn">重置</el-button>
                <el-color-picker v-model="value.attr[item].value" show-alpha></el-color-picker>
              </div>
            </div>
          </div>
          <div class="attr-item-typestyle" v-if="['a6'].includes(item) && value.attr['a4'].value=='1'">
            <div class="attr-item-label">{{ value.attr[item].label }}</div>
            <div class="attr-item-on">{{ value.attr[item].showList[value.attr[item].value] || value.attr[item].value }}</div>
            <div class="attr-item-value">
              <div class="colorPicker">
                <el-button type="text" @click="value.attr[item].value = value.attr[item].default" class="resetBtn">重置</el-button>
                <el-color-picker v-model="value.attr[item].value" show-alpha></el-color-picker>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="false" label="悬浮窗" name="attrsort1">
        <h4 class="dft-header">悬浮窗</h4>
        <div class="attr-item-box" v-for="(item, index) in value[activeName]" :key="index"
          :style="{ 'padding': value.attr[item].isUse == false ? '0' : '6px' }">
          
          <div class="attr-item-typestyle" v-if="item == 'a0'">
            <div class="attr-item-label">{{ value.attr[item].label }}</div>
            <div class="attr-item-value">
              <div class="temp-box">
                <el-select v-model="value.attr[item].value" placeholder="请选择" style="width: 100%;">
                  <el-option v-for="(ii, iiIndex) in value.attr[item].selectOption.keys" :key="ii" :label="value.attr[item].selectOption.values[iiIndex]" :value="ii" class="select-option"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="attr-item-typestyle" v-else-if="item == 'a1'">
            <div class="attr-item-label">{{ value.attr[item].label }}</div>
            <div class="attr-item-value">
              <div class="temp-box">
                <el-checkbox v-model="value.attr[item].value" true-label="1" false-label="0"></el-checkbox>
              </div>
            </div>
          </div>
          <div class="attr-item-typedata" v-else-if="item == 'a2'">
            <div class="attr-item-label">{{ value.attr[item].label }}</div>
            <div class="attr-item-value">
              <div class="addImgList">
                <div class="img_info">建议图片尺寸750*350。</div>
                <div class="imgList_box">
                  <div class="imgList-item" v-for="(ii,iiIndex) in value.attr[item].value" :key="iiIndex"
                    >
                    <div class="ii-img-box">
                      <el-image v-if="ii.img0" class="ii-img" :src="ii.img0" fit="scale-down"></el-image>
                      <div class="ii-img-btn">
                        <el-upload
                          class="avatar-uploader-d"
                          :action="$uploadURL"
                          :show-file-list="false"
                          :on-success="(res, file)=>{handleChangeUploadSuccess(res, file,ii,iiIndex,'0')}"
                          :before-upload="beforeUpload"
                        >
                          <div class="">
                            更换图片
                          </div>
                        </el-upload>
                      </div>
                      <div class="img-info">未选中</div>
                    </div>
                    <div class="ii-img-box">
                      <el-image v-if="ii.img1" class="ii-img" :src="ii.img1" fit="scale-down"></el-image>
                      <div class="ii-img-btn">
                        <el-upload
                          class="avatar-uploader-d"
                          :action="$uploadURL"
                          :show-file-list="false"
                          :on-success="(res, file)=>{handleChangeUploadSuccess(res, file,ii,iiIndex,'1')}"
                          :before-upload="beforeUpload"
                        >
                          <div class="">
                            更换图片
                          </div>
                        </el-upload>
                      </div>
                      <div class="img-info">选中</div>
                    </div>
                    <div class="ii-link-box">
                      <div class="ii-link-btn">
                        <i class="el-icon-top icon_btn" title="上移" v-if="!['home','my'].includes(ii.key)&&classType=='1'&&![1].includes(iiIndex)" @click="moveUp(value.attr[item].value,iiIndex)"></i>
                        <i class="el-icon-bottom icon_btn" title="下移" v-if="!['home','my'].includes(ii.key)&&classType=='1'&&iiIndex!=(value.attr[item].value.length-2)" @click="moveDown(value.attr[item].value,iiIndex)"></i>
                        <i class="el-icon-delete icon_btn" title="删除" v-if="!['home','classify','cart','my'].includes(ii.key)" @click="mDelete(value.attr[item].value,iiIndex)"></i>
                      </div>
                      <div class="ii-link-info-box">
                        <!-- <div class="ii-link-info"></div> -->
                        <div class="ii-link">
                          <el-input v-model="ii.name" placeholder=""></el-input>
                        </div>
                      </div>
                      <div class="ii-link-info-box" v-if="!['classify','cart','my'].includes(ii.key)">
                        <div class="ii-link-info">跳转设置</div>
                        <div class="ii-link">
                          <el-select v-model="ii.url" placeholder="请选择" filterable style="width: 100%;">
                            <el-option v-for="(llitem,index) in navigatelist" :key="index" :label="llitem.pageName" :value="llitem.pageCode"
                              class="select-option" :disabled="llitem.disabled" :title="llitem.disabled?'暂不支持':''"></el-option>
                          </el-select>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="upload_btn select_btn" @click="addCroup(value.attr[item].value)"
                  :style="value.attr[item].value.length>=5?{'cursor': 'not-allowed','margin-top': '8px'}:'margin-top: 8px;'">
                  <i class="el-icon-plus"></i>
                  {{ ` 添加导航 ${value.attr[item].value.length}/5` }}
                </div>
                <!-- <el-upload
                  class="avatar-uploader-d"
                  :action="$uploadURL"
                  :show-file-list="false"
                  :on-success="(res, file)=>{handleUploadSuccess(res, file,value.attr[item])}"
                  :before-upload="beforeUpload"
                >
                  <div class="upload_btn">
                    <i class="el-icon-plus" ></i>
                    添加图片
                  </div>
                </el-upload> -->
              </div>
            </div>
          </div>
          <div class="attr-item-typedata" v-else-if="item == 'a3'">
            <div class="attr-item-label">{{ value.attr[item].label }}</div>
            <div class="attr-item-value">
              <el-checkbox v-for="(cii,ciiIndex) in value.attr[item].checkboxList" :key="ciiIndex" v-model="value.attr[item].value[ciiIndex]" disabled>{{cii}}</el-checkbox>
            </div>
          </div>
          <div class="attr-item-typestyle" v-else-if="item == 'a4'">
            <div class="attr-item-label">{{ value.attr[item].label }}</div>
            <div class="attr-item-value">
              <el-radio-group v-model="value.attr[item].value" size="small">
                <el-radio-button label="1">自定义模式</el-radio-button>
                <el-radio-button label="2">系统默认</el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <div class="attr-item-typestyle" v-if="['a5'].includes(item) && value.attr['a4'].value=='1'">
            <div class="attr-item-label">{{ value.attr[item].label }}</div>
            <div class="attr-item-on">{{ value.attr[item].showList[value.attr[item].value] || value.attr[item].value }}</div>
            <div class="attr-item-value">
              <div class="colorPicker">
                <el-button type="text" @click="value.attr[item].value = value.attr[item].default" class="resetBtn">重置</el-button>
                <el-color-picker v-model="value.attr[item].value" show-alpha></el-color-picker>
              </div>
            </div>
          </div>
          <div class="attr-item-typestyle" v-if="['a6'].includes(item) && value.attr['a4'].value=='1'">
            <div class="attr-item-label">{{ value.attr[item].label }}</div>
            <div class="attr-item-on">{{ value.attr[item].showList[value.attr[item].value] || value.attr[item].value }}</div>
            <div class="attr-item-value">
              <div class="colorPicker">
                <el-button type="text" @click="value.attr[item].value = value.attr[item].default" class="resetBtn">重置</el-button>
                <el-color-picker v-model="value.attr[item].value" show-alpha></el-color-picker>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane v-if="false" label="顶部导航" name="attrsort2"></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import addClassPage from '../addClassPage.vue'
import { status } from 'nprogress'

export default {
  components: {
    draggable,
    addClassPage
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return { attr: {}, attrsort: [] }
      }
    }
  },
  model: {
    prop: 'value',
    event: 'changes'
  },
  data () {
    return {
      showDialog: false,
      showClassDialog: false,
      showSKDialog: false,
      gprefresh: true,
      showClassIndex: 0,
      showSKIndex: 0,
      activityList: [
        { label: '今日优惠', value: '1' },
        { label: '新品展示', value: '2' },
        { label: '爆款专区', value: '3' },
        { label: '新人专享', value: '4' },
        { label: '好物推荐', value: '5' },
        { label: '会员专区', value: '6' }
        // { label: '拼团', value: '7'},
        // { label: '砍价', value: '8'},
      ],
      navigatelist: [],
      groupRight: {
        name: 'itxst2',
        pull: false, // 拖出
        put: false // 拖入
      },
      btnloading: false,
      activeName: 'attrsort',
      // 模板默认数据-16
      assemblyAttr666: JSON.stringify(
            {
              attr: {
                a0: {
                  label: '样式选择',
                  value: '1',
                  type: 'data',
                  showList: {
                    '1': '标准版',
                    '2': '主图标版',
                    '3': '悬浮窗版',
                  },
                  selectOption: {
                    keys: ['1', '2', '3'],
                    values: ['标准版', '主图标版', '悬浮窗版']
                  },
                },
                a1: {
                  label: '仅选中时展示图标',
                  value: '0',
                  key: 'goodsStyle',
                  type: 'data',
                },
                a2: {
                  label: '编辑导航',
                  value: [
                    {
                      img0: 'http://146.56.248.225/resources/img/index.png',//未选中
                      img1: 'http://146.56.248.225/resources/img/index-active.png',//选中
                      name: '首页',
                      url: '',
                      key: 'home',
                    },
                    {
                      img0: 'http://146.56.248.225/resources/img/classify.png',//未选中
                      img1: 'http://146.56.248.225/resources/img/classify-active.png',//选中
                      name: '分类',
                      url: '',
                      key: 'classify',
                    },
                    {
                      img0: 'http://146.56.248.225/resources/img/cart.png',
                      img1: 'http://146.56.248.225/resources/img/cart-active.png',
                      name: '购物车',
                      url: '',
                      key: 'cart',
                    },
                    {
                      img0: 'http://146.56.248.225/resources/img/my.png',
                      img1: 'http://146.56.248.225/resources/img/my-active.png',
                      name: '我的',
                      url: '',
                      key: 'my',
                    }
                  ],
                  type: 'data',
                  tag: '',
                  sid: 'goods_weapp_s0',
                  groupList: [{
                    activityName: '',
                    activityCode: '',
                    activityTitle: '',
                    categoryList: []
                  }]
                },
                a3: {
                  label: '应用页面',
                  value: [true,true],
                  type: 'data',
                  checkboxList: ['店铺主页','个人中心']
                },

                a4: {
                  label: '导航图标色',
                  value: '2',
                  sid: 'goods_weapp_s12',
                  showList: {
                    '1': '自定义模式',
                    '2': '系统默认'
                  },
                  key: 'goodsTag',
                  type: 'style',
                  tag: 'radio'
                },
                a5: {
                  label: '未选中',
                  value: '#666666',
                  sid: 'attr_s',
                  showList: {},
                  default: '#666666',
                  key: 'background',
                  type: 'style',
                  tag: 'ColorPicker'
                },
                a6: {
                  label: '选中',
                  value: '#FF4444',
                  sid: 'attr_s',
                  showList: {},
                  default: '#FF4444',
                  key: 'background',
                  type: 'style',
                  tag: 'ColorPicker'
                },

                b1: {
                  label: '主窗口',
                  value: [
                    {
                      img0: 'http://146.56.248.225/resources/img/index.png',//未选中
                      img1: 'http://146.56.248.225/resources/img/index-active.png',//选中
                      name: '首页',
                      url: '',
                      key: 'home',
                    },
                  ],
                  type: 'data',
                  tag: '',
                  sid: 'goods_weapp_s0',
                  groupList: [{
                    activityName: '',
                    activityCode: '',
                    activityTitle: '',
                    categoryList: []
                  }]
                },
                b2: {
                  label: '编辑导航',
                  value: [
                    {
                      img0: 'http://146.56.248.225/resources/img/index.png',//未选中
                      img1: 'http://146.56.248.225/resources/img/index-active.png',//选中
                      name: '首页',
                      url: '',
                      key: 'home',
                    },
                    {
                      img0: 'http://146.56.248.225/resources/img/classify.png',//未选中
                      img1: 'http://146.56.248.225/resources/img/classify-active.png',//选中
                      name: '分类',
                      url: '',
                      key: 'classify',
                    },
                    {
                      img0: 'http://146.56.248.225/resources/img/cart.png',
                      img1: 'http://146.56.248.225/resources/img/cart-active.png',
                      name: '购物车',
                      url: '',
                      key: 'cart',
                    },
                    {
                      img0: 'http://146.56.248.225/resources/img/my.png',
                      img1: 'http://146.56.248.225/resources/img/my-active.png',
                      name: '我的',
                      url: '',
                      key: 'my',
                    }
                  ],
                  type: 'data',
                  tag: '',
                  sid: 'goods_weapp_s0',
                  groupList: [{
                    activityName: '',
                    activityCode: '',
                    activityTitle: '',
                    categoryList: []
                  }]
                },
              },
              attrsort: [
                'a0', 'a1', 'a2', 'a3', 'a4', 'a5', 'a6'
              ],
              attrsort1: [
                'a0', 'a1', 'a2', 'a3', 'a4', 'a5', 'a6'
              ],
              attrsort2: [
                'a0', 'a1', 'a2', 'a3', 'a4', 'a5', 'a6'
              ],
              attrType: ['attrsort', 'attrsort1', 'attrsort2']
            }
          )
    }
  },
  watch: {
    // value: {
    //   handler: function(newVal){
    //     if(newVal){
    //       this.$nextTick(() => {
    //         // console.log('comp--D-ata',newVal)
    //       });

    //     }
    //   },
    //   deep: true
    // }
  },
  computed: {
    // 分类
    classType () {
      return this.value?.attr?.['a0']?.value
    },
  },
  created () {
    this.getNavigatelist()
  },

  mounted () {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData () {
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    // 获取数据
    getNavigatelist () {
      var that = this
      const queryInfo = {
        pageSize: 10,
        currPage: 1,
        condition: {
          merchantCode: JSON.parse(localStorage.getItem("userInfo"))?.userInfo?.merchantCode,
          status: '1',
        }
      }
      that.$http
        .post('/merchantRenovationPage/queryList', queryInfo.condition)
        .then(function (response) {
          if (response.data.code == 200) {
            that.navigatelist = response.data.data
          }
        })
    },
    addClass (index) {
      this.showClassIndex = index
      this.showClassDialog = true
      console.log('??-0', index, this.showClassDialog && this.showClassIndex == index)
    },
    clearC (val) {
      val.splice(0, val.length)
    },
    addSK (index) {
      console.log('??-1', index)
      this.showSKIndex = index
      this.showSKDialog = true
    },
    // 模式变更
    handleModeChange (val) {
      if (val == '2') {
        this.value.attr['a1'].value = 2
      }
      console.log('/././.---', val, this.value)
    },
    handleTagClose (value, i) {
      value.splice(i, 1)
    },
    addCoupon (list) {
      this.showDialog = true
    },
    addCroup (item) {
      if(item.length>=5){
        return
      }
      if(this.btnloading){
        return
      }
      this.btnloading = true
      setTimeout(() => {
        this.btnloading = false
      }, 300)
      // console.log('/././.---', this.value.attr['a2'].value, item)
      const _normal = {
        img0: '',//未选中
        img1: '',//选中
        name: '',
        url: '',
        key: 'normal'
      }
      switch(this.classType){
        case '1':
          item.splice( 2, 0, _normal )
          break;
        default:
          if(item.length == 3){
            item.splice( 1, 0, _normal )
          }else{
            item.splice( 3, 0, _normal )
          }
          break;
      }
    },
    setactivity (val, iitem) {
      const _i = this.activityList.findIndex(iii => iii.value == val)
      iitem.activityName = this.activityList[_i].label
      iitem.activityTitle = this.activityList[_i].label
    },
    // 存储秒杀商品
    // 图片上传成功处理
    handleUploadSuccess (res, file, item) {
      const _imgUrl = file.response.data.url
      item.value.push(
        {
          img: _imgUrl,
          link: '',
          url: '',
        }
      )
    },
    // 修改图片上传成功处理
    handleChangeUploadSuccess (res, file, ii, iiIndex,type) {
      const _imgUrl = file.response.data.url
      if(type == '1'){
        ii.img1 = _imgUrl
      }else{
        ii.img0 = _imgUrl
      }
    },
    // 图片上传之前处理
    beforeUpload (file) {
      // const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isLt2M) {
      //   this.$message.error("上传图片大小不能超过 2MB!");
      // }
      // return  isLt2M;
    },
    // 上移
    moveUp (value, iiIndex) {
      value[iiIndex] = value.splice(iiIndex - 1, 1, value[iiIndex])[0]
    },
    // 下移
    moveDown (value, iiIndex) {
      value[iiIndex] = value.splice(iiIndex + 1, 1, value[iiIndex])[0]
    },
    // 删除
    mDelete (value, iiIndex) {
      value.splice(iiIndex, 1)
    },
    goBack (val) {
      // this.$refs.addCouponPage.dialogVisible = false
      // console.log('l;l;',val)
      this.showDialog = false
      this.showClassDialog = false
      this.showSKDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
// @import url(../storecommonattr.less);
.dft-attr_container {
    width: 100%;
    box-sizing: border-box;
    padding: 8px;
  }

  .dft-header {
    margin: 5px 0;
  }

  .attr-item-box {
    // padding: 6px 6px;

    .attr-item-typedata {
      // margin-bottom: 10px;
      margin: 6px 10px;

      .attr-item-label {
        margin-bottom: 5px;
        font-size: 14px;
      }

      .attr-item-value {
        .temp-box {
          display: flex;
          flex-wrap: wrap;

          .temp-item {
            width: calc((100% - 36px)/6);
            height: 90px;
            margin: 0 3px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            .temp-item-img {
              width: 48px;
              height: 48px;
              margin-bottom: 8px;
            }

            .temp-item-name {
              font-weight: 400;
              font-size: 11px;
              line-height: 20px;
              text-align: center;
              color: #333;

              .mini_span {
                /*transform: scale(.7);*/
              }
            }
          }

          .active_temp-item {
            .temp-item-name {
              color: #155bd4;
            }
          }
        }

        .addImgList {
          width: 100%;
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;

          .img_info {
            color: #969799;
            font-weight: 400;
            margin-top: 8px;
            white-space: pre-wrap;
            font-size: 13px;
          }

          .imgList_box {
            width: 100%;
            box-sizing: border-box;
            overflow-y: auto;

            .imgList-item {
              border: 1px solid #e0e0e0;
              margin: 12px 5px;
              padding: 4px;
              box-sizing: border-box;
              display: flex;

              .ii-img-box {
                width: 80px;
                height: 90px;
                position: relative;
                display: flex;
                flex-direction: column;

                .ii-img {
                  width: 100%;
                  height: 100%;
                }

                .ii-img-btn {
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  width: 100%;
                  height: 20px;
                  background-color: rgba($color: #000000, $alpha: .5);
                  text-align: center;
                  font-size: 13px;
                  color: #ffffff;
                  cursor: pointer;
                }
                .img-info{
                  position: absolute;
                  height: 20px;
                  bottom: -24px;
                  width: 100%;
                  font-size: 12px;
                  color: #999;
                  text-align: center;
                }
              }
              .ii-img-box+.ii-img-box{
                margin-left: 10px;
              }

              .ii-link-box{
                width: calc(100% - 170px);
                flex: 1;
                box-sizing: border-box;
                height: 110px;
                padding: 0 8px;
                display: flex;
                flex-direction: column;
                .ii-link-btn{
                  display: flex;
                  justify-content: flex-end;
                  font-size: 18px;
                  color: #969696;
                  min-height: 30px;
                  .icon_btn{
                    padding: 2px;
                    cursor: pointer;
                    margin: 4px;
                  }
                }
                .ii-link-info-box{
                  display: flex;
                  align-items: center;
                }
                .ii-link-info{
                  font-weight: 400;
                  font-size: 13px;
                  line-height: 20px;
                  margin-top: 4px;
                  color: #999;
                  width: 70px;
                }
                .ii-link{
                  width: 100%;
                }
              }
            }
          }

          .upload_btn {
            background: #efefef;
            border-radius: 2px;
            padding: 6px 10px 6px 14px;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            width: -webkit-fit-content;
            width: -moz-fit-content;
            width: fit-content;
            margin: 0 auto;
            color: #333;
            cursor: pointer;
          }

          .comp-item {
            width: calc(100% - 12px);
            margin: 8px 6px;
            padding: 6px 10px 6px 14px;
            box-sizing: border-box;
            background-color: #fff;
            border-radius: 2px;
            display: flex;
            align-items: center;
            border-radius: 2px;
            background-color: #fff;
            box-shadow: 0 0 4px 0 rgba(10, 42, 97, .2);

            .goodsinfo {
              padding-left: 8px;
              font-size: 13px;
            }

            /*cursor: grab;*/
            position: relative;
          }
          .groupitem{
            flex-direction: column;
            position: relative;
            background: #fcfcfc;
            .groupitem_line{
              width: 100%;
              margin: 6px 0;
              background: #fff;
              position: relative;
              .ctag_item{
                margin-right: 4px;
              }
            }
            .g_l_label{
              flex-shrink: 0;
              padding-bottom: 4px;
              color: #969799;
            }
            .clear_box{
              position: absolute;
              top: 1px;
              right: 8px;
              width: 100%;
              margin-bottom: 6px;
              display: flex;
              justify-content: flex-end;
              .el-button{
                padding: 0 8px;
                height: 26px;
              }
            }
            .g_taglist{
              margin-top: 8px;
            }
            // .ii-link-btn{
            //   position: absolute;
            //   top: 2px;
            //   right: 4px;
            //   display: flex;
            //   justify-content: flex-end;
            //   align-items: center;
            //   font-size: 18px;
            //   color: #969696;
            //   display: none;

            //   .icon_btn {
            //     font-size: 18px;
            //     padding: 2px;
            //     margin: 0 2px;
            //     cursor: pointer;
            //     &:hover{
            //       color: #155bd4;
            //     }
            //   }
            // }
            // &:hover {
            //   .ii-link-btn {
            //     display: flex;
            //   }
            // }
          }
          .select_btn {
            width: 80%;
            margin: 8px 0 0;
            box-sizing: border-box;
            background-color: #fff;
            border: 1px solid #155bd4;
            border-radius: 2px;
            color: #155bd4;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }

    .attr-item-typestyle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      margin: 6px 10px;

      .attr-item-label {
        color: #333333;
        margin-right: 12px;
      }

      .attr-item-on {
        color: #333333;
        margin-right: 8px;
        font-size: 12px;
      }

      .attr-item-value {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }

  }

  .colorPicker {
    height: 40px;
    display: flex;
    align-items: center;
  }

  .custon_slider {
    width: 100%;

    /deep/.el-slider__input {
      width: 60px;
    }

    /deep/.el-slider__runway.show-input {
      margin-left: 8px;
      margin-right: 80px;
    }
  }

  .btn-icon {
    line-height: 20px;
    color: #f44;
  }

  .select-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .select-btn {
    height: 18px;
    padding: 0 8px;
  }

  .info-set {
    position: absolute;
    bottom: 0;
    left: 0;
    color: #969799;
    font-size: 12px;
  }
</style>
